import { lazy, Suspense } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ErrorBoundary } from './ErrorBoundary.tsx'
import { queryClient } from '../queryClient.ts'

const App = lazy(() => import('./App.tsx'))

/** Accessible feedback while the route bundle is loading. */
export function PortalLoading() {
  return <main className="startup-loading" role="status" aria-busy="true" aria-live="polite">
    <h1>Loading portal</h1>
    <p>Preparing your workspace...</p>
  </main>
}

/** The authenticated portal shell and its route-level loading boundary. */
export function PortalRoot() {
  return <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<PortalLoading />}>
        <App />
      </Suspense>
    </QueryClientProvider>
  </ErrorBoundary>
}
